export default __webpack_public_path__ + "static/media/project_medmex_0.bcbed227.png";